const LinkText = theme => {
  return {
    fontFamily: ['futura-pt','sans-serif'],
    fontSize: theme.typography.body2.fontSize / .5,
    color: "#333",
    textUnderlinePosition: "under",
  }
}

export default LinkText



// WEBPACK FOOTER //
// ./src/styles/mixins/link.js